<template>
    <v-container>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>
        <v-form ref="formDatos" lazy-validation> 
            <v-card>
                <v-card-text>
                    <v-row v-if="Datos.tipo != '' && Datos.tipo != 'notasSiagie'">
                        <v-col cols="12" id="btn_generar_excel" class="d-flex flex-row-reverse pt-0">
                            <v-btn color="success" v-on:click="generarExcel" :loading="generandoReporte == 1">
                                Generar Plantilla
                                <v-icon class="pl-2">fa-file-excel</v-icon>
                            </v-btn>                            
                        </v-col>
                        
                    </v-row>
                    <v-row v-if="Datos.tipo == 'notasSiagie'" dense class="d-flex flex-row-reverse pt-0">
                        <div class="d-flex flex-row-reverse ml-5">
                            <h3>Seleccione un documento</h3>
                        </div>
                        <v-col cols="12" class="d-flex flex-row-reverse pt-0">
                        <input type="file" name="subirArchivo" ref="myFileImagen" :disabled="Datos.tipo == ''"
                            @change="onFileChange" accept=".xls, .xlsx" />
                        <!-- <v-file-input name="subirArchivo" ref="myFileImagen" :disabled="Datos.tipo === ''"
                            accept=".xls, .xlsx" @change="onFileChange">
                            <template v-slot:prepend>
                            <v-icon>mdi-upload</v-icon>
                            </template>
                            <template v-slot:append>
                            </template>
                        </v-file-input> -->
                        <ButtonComp v-if="fileDoc" @click="clearFileInput" deleteButton
                            tooltipText="Eliminar documento adjunto" />

                        </v-col>
                    </v-row>
                    <v-dialog v-model="dialogimport" hide-overlay persistent width="300">
                        <v-card color="primary" dark>
                            <v-card-text class="text-center">
                                Importando datos
                                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-row>
                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-select label="Formato de datos: " v-model="Datos.tipo"  @change="showFilters(Datos.tipo)" 
                                :items="listTipo" item-value="codigo" item-text="descripcion">
                            </v-select>
                        </v-col>
                        <v-col cols="12" v-if="Datos.tipo != ''">
                            <!-- Filtros -->                             
                            <v-card class="card">
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-select
                                            @change="seleccionarAnioLectivo(anioLectivoSelected)"
                                            :items="aniosLectivos"
                                            v-model="anioLectivoSelected"
                                            :item-text="anoLectivoCompuesto"
                                            item-value="idAnioLectivo"
                                            label="Año lectivo"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="4" v-if="Datos.tipo == 'alumnos' || Datos.tipo == 'familiares' || Datos.tipo == 'notasSiagie'">
                                            <v-select
                                            @change="seleccionarNivel(nivelSelected)"
                                            :items="niveles"
                                            v-model="nivelSelected"
                                            item-text="desc_nivel"
                                            item-value="id_nivel"
                                            label="Nivel"
                                            ></v-select>                                                    
                                        </v-col>
                                        <v-col cols="12" sm="4" v-if="Datos.tipo == 'alumnos' || Datos.tipo == 'familiares' || Datos.tipo == 'notasSiagie'">
                                            <v-select
                                            @change="seleccionarGrado(gradoSelected)"
                                            :items="grados"
                                            v-model="gradoSelected"
                                            item-text="desc_grado"
                                            item-value="id"
                                            label="Grado"
                                            ></v-select> 
                                        </v-col>
                                        <v-col cols="12" sm="4" v-if="Datos.tipo == 'alumnos' || Datos.tipo == 'familiares' || Datos.tipo == 'notasSiagie'">
                                            <v-select
                                            @change="seleccionarSeccion(seccionSelected)"
                                            :items="secciones"
                                            v-model="seccionSelected"
                                            item-text="nombre_seccion"
                                            item-value="id"
                                            label="Sección"
                                            ></v-select> 
                                        </v-col> 
                                        <v-col cols="12" sm="4" v-if="Datos.tipo == 'notasSiagie'">
                                            <v-select
                                            @change="selectPeriodo(periodoSelected)"
                                            :items="periodos"
                                            v-model="periodoSelected"
                                            item-text="nombre_periodo"
                                            item-value="id"
                                            label="Período"
                                            ></v-select> 
                                        </v-col>
                                        <v-col cols="12" sm="4" v-if="Datos.tipo == 'alumnos' || Datos.tipo == 'familiares'">
                                            <v-select
                                            @change="seleccionarAlumno(alumnoSelected)"
                                            :items="alumnos"
                                            v-model="alumnoSelected"
                                            item-text="nombre_apellido"
                                            item-value="id"
                                            label="Estudiante"
                                            ></v-select> 
                                        </v-col>                                                                             
                                        <v-col cols="12" sm="4" v-if="Datos.tipo != 'notasSiagie'">
                                            <v-select
                                            @change="seleccionarRango(rangoSelected)"
                                            :items="cantidadResultados"
                                            v-model="rangoSelected"
                                            item-text="descripcion"
                                            item-value="id"
                                            label="Resultados por página"
                                            ></v-select> 
                                        </v-col>                                                                                                                                    
                                    </v-row>
                                </v-card-text>
                            </v-card> 
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-form>
    </v-container>
</template>
<script>
import {mapMutations, mapGetters} from 'vuex';
//mapActions,mapState
import axios, { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';

export default {

    components:{
        ButtonComp
    },
    data:() => ({
        menu1: false,
        menu2: false,
        date:'',
        date2:'',
        dateFormatted:'',
        dateFormatted2: '',
        Datos: {
            tipo: "",
            id_colegio: parseInt(sessionStorage.id_colegio)
        },
        generandoReporte: 0,
        showFilter:0,
        rangoSelected: '50',
        anioLectivoSelected:'-1',
        nivelSelected:'-1',
        gradoSelected:'-1',
        seccionSelected:'-1',
        areaSelected: '-1',
        alumnoSelected: '-1',
        periodoSelected: '-1',
        fileDoc: null,
        dialogimport: false,

        listTipo: [
            {codigo: "alumnos", descripcion: "Registro de información personal del estudiante"}, 
            {codigo: "familiares", descripcion: "Registro de información familiar del estudiante"},
            {codigo: "personal", descripcion: "Registro de información personal del trabajador"},
            {codigo: "notasSiagie", descripcion: "Registro de información de notas (SIAGIE)"},
        ],

        aniosLectivos: [],
        niveles: [],
        grados: [{id:'-1', desc_grado:'Todos'}],
        secciones: [{id:'-1', nombre_seccion:'Todos'}],
        areas:[{id_area:'-1', desc_area:'Todos'}],
        alumnos: [{id:'-1', nombre_apellido:'Todos'}],
        periodos: [{id:'-1', nombre_periodo:'Todos'}],
        cantidadResultados: [
            {codigo:'1', descripcion: '1'},
            {codigo:'50', descripcion: '50'},
            {codigo:'50', descripcion: '100'},
            {codigo:'50', descripcion: '200'},
        ]
    }),

    watch: {
      date () {
        this.dateFormatted = this.formatDate(this.date)
      },
      date2 () {
        this.dateFormatted2 = this.formatDate(this.date2)
      },      
    },    
    methods: {
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        hide: async function() {
            this.anioLectivoSelected.destroy()
            this.aniosLectivos.destroy()
        },
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////       
        
        
        showFilters: function(tipo) {
            this.Datos.tipo = tipo;
            if (this.showFilter != 0) {
                this.limpiarFiltros();
            }
            this.showFilter += 1;
        },

        getPerfiles: async function() {
            let response = await axios.get('/reporte/formatoReporte/perfiles/'+this.Datos.id_colegio)
            let perfilesList = response.data
            perfilesList.unshift({id:'-1', descripcion_perfil:'Todos'})
            this.perfiles = perfilesList
        },
        
        getAnioLectivos: async function() {
            let response = await axios.get('/reporte/formatoReporte/aniosElectivos/'+this.Datos.id_colegio)
            let anioLectivosList = response.data
            anioLectivosList.unshift({idAnioLectivo:'-1', fecha_inicio:'Todos'})
            this.aniosLectivos = anioLectivosList         
        },
        
        getNiveles: async function(idAnioLectivo){

            let response = await axios.post('/reporte/formatoReporte/getNiveles', {
                idAnioLectivo: idAnioLectivo,
                idColegio: this.Datos.id_colegio
            })
            console.log(response)
            let nivelesist = (response.data.legth == 0) ? new Array():response.data
            nivelesist.unshift({id_nivel:'-1', desc_nivel:'Todos'})
            this.niveles = nivelesist     

        },
        getGrados: async function(idAnioLectivo, idNivel) {

            let response = await axios.post('/reporte/formatoReporte/getGrados', {
                idAnioLectivo: idAnioLectivo,
                idColegio: this.Datos.id_colegio,
                idNivel: idNivel
            })
            let gradosList = response.data
            gradosList.unshift({id:'-1', desc_grado:'Todos'})
            this.grados = gradosList

        },
        


        getGradosAdm: async function(idAnioLectivo, idNivel) {

            let response = await axios.post('/reporte/formatoReporte/getGradosAdm', {
                idAnioLectivo: idAnioLectivo,
                idColegio: this.Datos.id_colegio,
                idNivel: idNivel
            })
            let gradosList = response.data
            gradosList.unshift({id:'-1', desc_grado:'Todos'})
            this.grados = gradosList

        },

        getSeccion: async function(idAnioLectivo, idGrado) {
            let response = await axios.post('/reporte/formatoReporte/getSecciones', {
                idAnioLectivo: idAnioLectivo,
                idColegio: this.Datos.id_colegio,
                idGrado: idGrado
            })
            let seccionesList = response.data
            seccionesList.unshift({id:'-1', nombre_seccion:'Todos'})
            this.secciones = seccionesList
        },
        

        getSeccionAdm: async function(idAnioLectivo, idGrado) {
            let response = await axios.post('/reporte/formatoReporte/getSecciones', {
                idAnioLectivo: idAnioLectivo,
                idColegio: this.Datos.id_colegio,
                idGrado: idGrado
            })
            let seccionesList = response.data
            seccionesList.unshift({id:'-1', nombre_seccion:'Todos'})
            this.secciones = seccionesList
        },


        getAreas: async function(idAnioLectivo, idNivel) {

                let response = await axios.post('/administrativo/area/areasNivelAdmin', {
                    idAnioLectivo: idAnioLectivo,
                    idColegio: this.Datos.id_colegio,
                    idNivel: idNivel
                })
                let areasList = response.data[0].json
                areasList.unshift({id_area:'-1', desc_area:'Todos'})
                this.areas = areasList

        }, 
        
        getAreasAdm: async function(idAnioLectivo, idGrado) {

                let response = await axios.post('/reporte/formatoReporte/getAreasAdm', {
                    idAnioLectivo: idAnioLectivo,
                    idColegio: this.Datos.id_colegio,
                    idGrado: idGrado
                })

                let areasList = response.data
                areasList.unshift({id:'-1', desc_area:'Todos'})
                this.areasAdm = areasList

        },

        getPeriodos: async function (idAnioLectivo){
            let response = await axios.post('/reporte/formatoReporte/getPeriodos',{
                idColegio: this.Datos.id_colegio,
                idAnioLectivo,
                idNivel: this.nivelSelected
            })
            let periodosList = response.data
            periodosList.unshift({id:'-1', nombre_periodo:'Todos'})
            this.periodos = periodosList
        },
                
        getAlumnos: async function(idAnioLectivo, idSeccion){
            let response = await axios.post("/administrativo/seccion/secalu/fil/", {
                id_colegio: this.Datos.id_colegio,
                id_ano_lectivo: idAnioLectivo,
                id_seccion: idSeccion,
            });
            console.log('alumnos: ', response.data)
            let listAlumnos = response.data;
            listAlumnos.unshift({id:'-1', nombre_apellido:'Todos'});
            this.alumnos = listAlumnos;
        }, 

        seleccionarRango: async function(id) {
            this.rangoSelected = id
        },

        seleccionarColegio: async function(idColegio){
            this.getAnioLectivos(idColegio);
        },

        seleccionarAnioLectivo: async function(idAnioLectivo) {
            this.periodos = []
            this.docentes = []
            this.nivelesDocente = []
            this.gradosDocente = []
            this.seccionesDocente = []
            this.areasDocente = []
            this.cursosDocente = []
            this.anioLectivoSelected = idAnioLectivo
            // this.getPeriodos(this.idColegio, idAnioLectivo)
            this.getNiveles(idAnioLectivo)
        },

        seleccionarNivel: async function(idNivel) {
            if (this.anioLectivoSelected != '-1') {
                this.nivelSelected = idNivel
                this.getGrados(this.anioLectivoSelected, idNivel)
                this.getAreas(this.anioLectivoSelected, idNivel)
                this.getPeriodos(this.anioLectivoSelected)
            }
        },
    
        seleccionarGrado: async function(idGrado) {
            this.gradoSelected = idGrado
            this.getSeccion(this.anioLectivoSelected, idGrado)
        }, 

        seleccionarSeccion: async function(idSeccion) {
            this.seccionSelected = idSeccion  
            this.getAlumnos(this.anioLectivoSelected, this.seccionSelected) 
        },     

        seleccionarArea: async function(idArea) {
            this.areaSelected = idArea  
            this.getCursos(this.anioLectivoSelected,  this.nivelSelected,  this.gradoSelected, idArea)
        }, 

        seleccionarAlumno: async function(idAlumno) {
            this.alumnoSelected = idAlumno
        },

        selectPeriodo: function(idPeriodo){
            this.periodoSelected = idPeriodo;
        },

        seleccionarPeriodo: async function(idPeriodo){
            this.docentes = []
            this.nivelesDocente = []
            this.gradosDocente = []
            this.seccionesDocente = []
            this.areasDocente = []
            this.cursosDocente = []
            this.areasDocente = []            
            this.periodoSelected = idPeriodo
            this.getDocentes(this.anioLectivoSelected)
        },                                             

        anoLectivoCompuesto(item) {
            if (item.fecha_inicio != 'Todos') {
                return item.fecha_inicio+'-'+item.nom_anolectivo;
            }
            return 'Todos';
        },

        limpiarFiltros: async function() {
            //this.aniosLectivos = [];
            this.periodos = [{id:'-1', nombre_periodo:'Todos'}]
            this.niveles = [{id_nivel:'-1', desc_nivel:'Todos'}];
            this.nivelesDocente = [{id_nivel:'-1', desc_nivel:'Todos'}];
            this.grados = [{id:'-1', desc_grado:'Todos'}];
            this.secciones = [{id:'-1', nombre_seccion:'Todos'}];
            this.areas = [{id_area:'-1', desc_area:'Todos'}];
            this.areasAdm = [{id:'-1', desc_area:'Todos'}];
            this.areasDocente = [{id_area:'-1', desc_area:'Todos'}];
            this.rangoSelected = '50';
            this.anioLectivoSelected = '-1';
            this.nivelSelected = '-1';
            this.gradoSelected = '-1';
            this.seccionSelected = '-1';
            this.periodoSelected = '-1';
            this.areaSelected = '-1';
            this.alumnoSelected = '-1';
            this.date = '';
            this.date2 = '';
        },

        generarExcel: async function() {
            try {
                this.generandoReporte = 1
                this.setEnviarMens({tipo: 'S', mensaje: 'Generando reporte…', tiempo:3000})                
                let data = {};
                let archivoADescargar='';
             
                data =  {
                    colegio: this.Datos.id_colegio,
                    anioLectivo: parseInt(this.anioLectivoSelected),
                    nivel: parseInt(this.nivelSelected),
                    grado: parseInt(this.gradoSelected),
                    seccion: parseInt(this.seccionSelected),
                    alumno: parseInt(this.alumnoSelected),
                    tamanioPorHoja: parseInt(this.rangoSelected),
                    bucket: BUCKET_ORIGIN_SPACE
                }

                let response;
                //generamos el reporte
                if (this.Datos.tipo == 'alumnos') {
                    response = await axios.post("/administrativo/migracionDatos/generarReporteAlumnos", data);                
                } else if (this.Datos.tipo == 'familiares') {
                    response = await axios.post("/administrativo/migracionDatos/generarReporteFamiliares", data);                
                } else if (this.Datos.tipo == 'personal') {
                    response = await axios.post("/administrativo/migracionDatos/generarReportePersonal", data);   
                }  

                let dataResponse = response.data
                this.generandoReporte = 0
                this.setEnviarMens({tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo:3000})  
                if (dataResponse.messageT == 'S') {
                    archivoADescargar = dataResponse.fileToDownload;
                    this.bajarReporte(dataResponse.nameReport, archivoADescargar);
                }              
            } catch (error) {
                console.log(error)
                this.generandoReporte = 0
                this.setEnviarMens({tipo: 'E', mensaje: 'No se pudo generar el reporte. Por favor, vuelva a intentarlo.', tiempo:3000})
            }             

        }, 

        async bajarReporte(nameReport, archivoADescargar){
            axios({
                url: '/reporte/formatoReporte/bajarReporte/'+nameReport,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                this.setEnviarMens({tipo: 'S', mensaje: 'Descargando reporte', tiempo:3000})                

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', archivoADescargar);
                document.body.appendChild(link);
                link.click();
                link.remove()
                window.URL.revokeObjectURL(url);
            }); 
        },


        // métodos de exportación siagie

        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.fileDoc = files[0];
            this.dialogimport = true
            this.saveDocumento();
        },

        clearFileInput() {
            this.fileDoc = null;
            this.$refs.myFileImagen.value = '';
        },

        saveDocumento() {
            switch (this.Datos.tipo) {
                case 'notasSiagie':
                    this.fillScores()
                    break;
            
                default:
                    break;
            }
        },

        async fillScores (){
            if (this.fileDoc) {
                let formData = new FormData();

                formData.append('templateSameName', this.fileDoc);
                formData.append("id_colegio", this.Datos.id_colegio);
                formData.append("id_ano_lectivo", this.anioLectivoSelected);
                formData.append("id_nivel", this.nivelSelected);
                formData.append("id_grado", this.gradoSelected);
                formData.append("id_periodo", this.periodoSelected);
                formData.append("id_seccion", this.seccionSelected);
                
                if (this.Datos.id_colegio == "-1" || this.anioLectivoSelected == "-1" || this.nivelSelected == "-1" || this.gradoSelected == "-1" || this.periodoSelected == "-1" || this.seccionSelected == "-1") {
                    this.setEnviarMens({
                        tipo: "W",
                        mensaje: "Faltan filtros por añadir",
                        tiempo: null,
                    })
                    this.dialogimport = false;
                    return
                }

                try {
                    let resp = await axios.post('administrativo/migracionDatos/notasSiage', formData)


                    this.setEnviarMens({
                        tipo: resp.data.messageT,
                        mensaje: resp.data.message,
                        tiempo: null,
                    });

                    if (resp.data) {
                        let archivoADescargar = "";
                        if (resp.data.messageT == "S") {
                            archivoADescargar = resp.data.fileToDownload;
                            await this.bajarReporte(resp.data.nameReport, archivoADescargar);
                        }
                    }
                    this.dialogimport = false;
                    this.clearFileInput();
                } catch (error) {
                    console.error(error);
                    this.dialogimport = false;
                    this.setEnviarMens({
                        tipo: "E",
                        mensaje: `Error en subir Archivo`,
                        tiempo: null,
                    });
                }
            }
        }
    },
    computed: {
        ...mapGetters('login', [ 'componenteEvento']),       
    }, 
    mounted(){
        // this.getPerfiles(idColegio);
        this.getAnioLectivos();
        this.getNiveles(null);
    },   
    created(){
        //this.actualizarParamentro()
        
    },
   
}
</script>

<style scoped>
table {
    width:100%;
    border-collapse: collapse;
}
table { border:1px solid #dddddd; }
th, td {
   border: 1px solid #dddddd;
   border-spacing: 0;
   border-collapse: collapse;
}
table td:first-child {
  width: 30%;
}
table td:nth-child(2) {
  width: 70%;
}
thead > tr{
    height: 40px;
    background: #1565c0;
    color: white;
}
.col-1, .col-2 {
    padding-top: 10px;
}
</style>


